"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _CommentTextEditor = _interopRequireDefault(require("../../../../../../CommentTextEditor")),
    _ContentView = _interopRequireDefault(require("../../../../../../../../ContentView"));

require("../styles/_comment-content.scss");

function Content(_ref) {
  var editMode = _ref.editMode,
      content = _ref.content,
      assetIds = _ref.assetIds,
      editorState = _ref.editorState,
      onUpdateContent = _ref.onUpdateContent,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      commentId = _ref.commentId,
      onFilesChange = _ref.onFilesChange,
      resourceOrganisationId = _ref.resourceOrganisationId;
  return _react["default"].createElement("div", {
    className: "comment-content"
  }, editMode ? _react["default"].createElement("div", {
    className: "comment-content__editor"
  }, _react["default"].createElement(_CommentTextEditor["default"], {
    editorState: editorState,
    onUpdateContent: onUpdateContent,
    onSave: onSave,
    onCancel: onCancel,
    assetIds: assetIds,
    commentId: commentId,
    onFilesChange: onFilesChange,
    organisationId: resourceOrganisationId
  })) : _react["default"].createElement(_ContentView["default"], {
    content: content,
    showAssets: !0
  }));
}

var _default = (0, _react.memo)(Content);

exports["default"] = _default;